import { Globe, Building2 } from 'lucide-react'
import { ReactNode } from 'react'

interface ScopeSectionProps {
  scope: 'global' | 'workspace'
  title: string
  description: string
  children: ReactNode
}

export function ScopeSection({ scope, title, description, children }: ScopeSectionProps) {
  const Icon = scope === 'global' ? Globe : Building2

  return (
    <section className="space-y-3">
      <header className="flex items-start gap-2.5">
        <Icon className="size-4 text-muted-foreground mt-0.5" />
        <div>
          <h3 className="text-sm font-semibold text-foreground leading-none">{title}</h3>
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        </div>
      </header>
      <div className="space-y-6">{children}</div>
    </section>
  )
}
